import AES from '@ali/aes-tracker';
import { watchPageVisiblityChange } from './utils/visibilityChange';
/**
 * 监控浏览器滚动响应延迟问题 https://www.atatech.org/articles/119955#5，U4 only
 */

(function () {
  if (!window.PerformanceTouchScrollLatencyTiming) {
    return;
  }

  var index = 0;
  var count = 0;
  var observer = new PerformanceObserver(function (list) {
    list.getEntries().forEach(function (entry) {
      // 当延迟大于100ms时上报
      count++;

      if (entry.duration > 100) {
        index++;
        AES.log('tsl', {
          // ssl or sul
          name: entry.name,
          // 延迟开始时间
          startTime: entry.startTime,
          // 延迟时间
          duration: entry.duration,
          // 滚动次数
          scrollTimes: count,
          // 延迟次数
          latencyTimes: index
        });
      }
    });
  });
  observer.observe({
    entryTypes: ["touchscrolllatency"]
  });
  var precount;
  watchPageVisiblityChange(function (isVisible) {
    if (!isVisible && count > 0 && precount !== count) {
      AES.log('tsl', {
        // 滚动次数
        scrollTimes: count,
        // 延迟次数
        latencyTimes: index
      });
      precount = count;
    }
  });
})();

export default AES;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-tsl@1.0.1@@ali/aes-tracker-plugin-tsl/es/index.js
// module id = null
// module chunks = 